import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VChip,{staticClass:"mr-2",attrs:{"color":`${_vm.color} elevation-7 mychip`,"outlined":!_vm.active,"text-color":_vm.active ? 'white' : '',"small":_vm.winWidth < 610,"pill":"","dark":""}},[_c(VAvatar,{class:`${_vm.avatarColor ? _vm.avatarColor : _vm.color} elevation-2 mr-3 white--text`,attrs:{"left":""}},[_vm._v(_vm._s(_vm.count))]),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }